// TIP-609 — the 1px rule the design draws between counters. Becomes a
// horizontal rule once the counters stack; see counterpartyBriefs.css.
import React from "react";
import "./counterpartyBriefs.css";

const CounterDivider = () => <div className="cb-divider" aria-hidden="true" />;

export default CounterDivider;
